// extracted by mini-css-extract-plugin
export default {"empty":"emptyPage_empty__MjW6z"};